module.exports = __webpack_public_path__ + "img/ramenmithintergrund.fab95553.jpg";